import gql from 'graphql-tag';
import { Apollo } from 'apollo-angular';
import { Subject } from 'rxjs';
import { CrmGraphql } from '../shared/constants/graphql-constants';
import { Injectable } from '@angular/core';

const getActiveApis = gql`
  query($apiName: String) {
    getActiveApis(apiName: $apiName) {
      apiId
      apiName
    }
  }
`;

@Injectable()
export class FeatureFlagsService {
  private featureFlags = [];
  /** Fires after active API names are stored so screens can re-check flags. */
  readonly featureFlagsUpdated$ = new Subject<void>();

  constructor(private apollo: Apollo) {}

  getAllEnabledFeatures = () =>
    this.apollo.use(CrmGraphql.QueryNameSpace).query<any>({
      query: getActiveApis,
      variables: {
        apiName: null
      },
      fetchPolicy: 'network-only'
      // tslint:disable-next-line: semicolon
    });

  isFeatureFlagEnabled(flag: string) {
    return this.featureFlags && this.featureFlags.includes(flag);
  }

  addEnabledFeatures(flags = []) {
    this.featureFlags = flags;
    this.featureFlagsUpdated$.next();
  }

  removeDisabledFeature(flag: string) {
    this.featureFlags = this.featureFlags.filter(el => el !== flag);
  }
}
